import translations from './ConditionGuidance.translations'

// Those colors are on the new branding only
export const GRADE_TO_COLOR = {
  12: '#E7729E',
  11: '#A366E8',
  10: '#6E83F0',
}

export const GRADE_TO_GALLERY = {
  10: [
    {
      url: '/img/product/funnel/smartphone_10_1.png',
      alt: translations.excellent1,
    },
    {
      url: '/img/product/funnel/smartphone_10_2.png',
      alt: translations.excellent2,
    },
    {
      url: '/img/product/funnel/smartphone_10_3.png',
      alt: translations.excellent3,
    },
  ],
  11: [
    {
      url: '/img/product/funnel/smartphone_11_1.png',
      alt: translations.good1,
    },
    {
      url: '/img/product/funnel/smartphone_11_2.png',
      alt: translations.good2,
    },
    {
      url: '/img/product/funnel/smartphone_11_3.png',
      alt: translations.good3,
    },
  ],
  12: [
    {
      url: '/img/product/funnel/smartphone_12_1.png',
      alt: translations.fair1,
    },
    {
      url: '/img/product/funnel/smartphone_12_2.png',
      alt: translations.fair2,
    },
    {
      url: '/img/product/funnel/smartphone_12_3.png',
      alt: translations.fair3,
    },
  ],
}
